"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _allianceAuthorization = require("@/api/allianceAuthorization");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      operationType: 'add',
      form: {
        unionBaseId: null,
        unionCode: 'TB',
        tips: null,
        tbBizBase: {
          memberId: null,
          pid: null,
          appKey: null,
          appSecret: null
        },
        jdBizBase: {
          unionId: null
        },
        pddBizBase: {
          clientId: null,
          clientSecret: null,
          mediaId: null,
          duoId: null
        },
        wphBizBase: {
          appKey: null,
          appSecret: null,
          pid: null
        }
      },
      rules: {
        'tbBizBase.memberId': [{
          required: true,
          message: '请输入联盟ID',
          trigger: 'blur'
        }],
        'tbBizBase.pid': [{
          required: true,
          message: '请输入推广位 PID',
          trigger: 'blur'
        }],
        'tbBizBase.appKey': [{
          required: true,
          message: '请输入淘宝开放平台App Key',
          trigger: 'blur'
        }],
        'tbBizBase.appSecret': [{
          required: true,
          message: '请输入淘宝开放平台App Secret',
          trigger: 'blur'
        }],
        'jdBizBase.unionId': [{
          required: true,
          message: '请输入京东联盟ID',
          trigger: 'blur'
        }],
        'pddBizBase.clientId': [{
          required: true,
          message: '请输入拼多多开放平台Client ID',
          trigger: 'blur'
        }],
        'pddBizBase.clientSecret': [{
          required: true,
          message: '请输入拼多多开放平台Client Secret',
          trigger: 'blur'
        }],
        'pddBizBase.mediaId': [{
          required: true,
          message: '请输入拼多多开放平台Media ID',
          trigger: 'blur'
        }],
        'pddBizBase.duoId': [{
          required: true,
          message: '请输入拼多多开放平台Duo ID',
          trigger: 'blur'
        }],
        'wphBizBase.appKey': [{
          required: true,
          message: '请输入唯品会开放平台App Key',
          trigger: 'blur'
        }],
        'wphBizBase.appSecret': [{
          required: true,
          message: '请输入唯品会开放平台App Secret',
          trigger: 'blur'
        }],
        'wphBizBase.pid': [{
          required: true,
          message: '请输入唯品会开放平台推广位 PID',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    openDialog: function openDialog(data) {
      this.operationType = data.operationType;
      this.form.unionCode = data.unionCode;
      if (data.operationType === 'edit') {
        this.form.unionBaseId = data.unionBaseId;
        this.onLoadBase(data.unionBaseId);
      }
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.resetForm('formRef');
      this.dialogVisible = false;
    },
    onLoadBase: function () {
      var _onLoadBase = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(unionBaseId) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                unionBaseId: unionBaseId,
                unionCode: this.form.unionCode
              };
              _context.n = 1;
              return (0, _allianceAuthorization.loadBase)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.form.tips = res.data.tips;
                if (this.form.unionCode === 'TB') {
                  this.form.tbBizBase = res.data.tbBizBase;
                } else if (this.form.unionCode === 'JD') {
                  this.form.jdBizBase = res.data.jdBizBase;
                } else if (this.form.unionCode === 'PDD') {
                  this.form.pddBizBase = res.data.pddBizBase;
                } else if (this.form.unionCode === 'WPH') {
                  this.form.wphBizBase = res.data.wphBizBase;
                }
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onLoadBase(_x) {
        return _onLoadBase.apply(this, arguments);
      }
      return onLoadBase;
    }(),
    onSaveBase: function () {
      var _onSaveBase = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                unionBaseId: this.form.unionBaseId,
                unionCode: this.form.unionCode,
                tips: this.form.tips
              };
              if (this.operationType === 'add') {
                delete params.unionBaseId;
              }
              if (this.form.unionCode === 'TB') {
                params.tbBizBase = this.form.tbBizBase;
              }
              if (this.form.unionCode === 'JD') {
                params.jdBizBase = this.form.jdBizBase;
              }
              if (this.form.unionCode === 'PDD') {
                params.pddBizBase = this.form.pddBizBase;
              }
              if (this.form.unionCode === 'WPH') {
                params.wphBizBase = this.form.wphBizBase;
              }
              _context2.n = 1;
              return (0, _allianceAuthorization.saveBase)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '保存成功'
                });
                this.$emit('saveSuccess');
                this.onClose();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onSaveBase() {
        return _onSaveBase.apply(this, arguments);
      }
      return onSaveBase;
    }(),
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log('valid');
          _this.$confirm('是否确认保存联盟账号基础信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.onSaveBase();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};